// Color helpers — shared across the app to eliminate nested ternaries.

export const COLOR = {
  green: "text-[#00FFA3]",
  red: "text-[#FF3B30]",
  amber: "text-[#F59E0B]",
  gray: "text-gray-300",
  grayMuted: "text-gray-400",
  white: "text-white",
};

export function rrColor(rr) {
  if (rr >= 3) return COLOR.green;
  if (rr >= 2) return COLOR.amber;
  return COLOR.gray;
}

export function winColor(prob) {
  if (prob >= 70) return COLOR.green;
  if (prob >= 55) return COLOR.amber;
  return COLOR.red;
}

export function pnlColor(value) {
  return value >= 0 ? COLOR.green : COLOR.red;
}

export function winRateColor(winRate) {
  if (winRate >= 60) return COLOR.green;
  if (winRate >= 40) return COLOR.amber;
  return COLOR.red;
}

export function convictionColor(conviction) {
  if (conviction === "STRONG") return COLOR.green;
  if (conviction === "MODERATE") return COLOR.amber;
  return COLOR.grayMuted;
}

export function tickColor(tick) {
  if (tick === "up") return COLOR.green;
  if (tick === "down") return COLOR.red;
  return COLOR.white;
}

export function confidenceColor(confidence) {
  if (confidence === "HIGH") return COLOR.green;
  if (confidence === "MEDIUM") return COLOR.amber;
  return COLOR.red;
}

export function rsiBgColor(rsi) {
  if (rsi > 70) return "#FF3B30";
  if (rsi < 30) return "#00FFA3";
  return "#6366F1";
}
